import React, { Component } from 'react'
import Link from '../../utils/link'
import BedBathCar from '../bed-bath-car'
import Fade from 'react-reveal/Fade'

class ProjectHeroBannerCard extends Component {

  render() {

    const { title, slug, images, propertyMeta, label, propertyType, single, acf, color } = this.props

    const sold = ( propertyMeta?.commercialListingType === 'sale' && (propertyMeta?.status !== "listing" && propertyMeta?.status !== "conditional") )

    let postType = propertyMeta?.status === 'management' ? 'rental' : 'property'
    if (propertyType === 'project') postType = 'project'
    let address = [];
    let image = ''
    let pathName = ''

    pathName = `/${postType}/${slug}/`
    image = acf.images.length > 0 ? acf.images[0].localFile.childImageSharp.original.src : ''
    if( title ) {
      address = title.split(",")
    }

    return (
      <div className={`property-hero-banner ${sold ? 'property-hero-banner--sold' : ''}`}>
        <Fade bottom distance='30px'>
          <div className='property-hero-banner__inner'>

            <div className='property-hero-banner__content'>

              <div className='property-hero-banner__menu'>

                <p className='heading heading--desktop'>{ label }</p>
                { postType=== 'project' && address.length >= 1 &&
                  <ul className='address'>
                    <li>{ address[0] }</li>
                    <li>{ address[1] }</li>
                  </ul>
                }
                { propertyType === 'project' &&
                  <BedBathCar color={color} carports={acf.stats.car} beds={ acf.stats.bed } baths={ acf.stats.bath } />
                }
                { postType === 'project' && acf?.displayPrice &&
                  <p className='price'>{ acf.displayPrice }</p>
                }

              </div>

              <div className='property-hero-banner__image'>

                { image !== '' && <img src={image} alt={title} /> }

                <div className={`sold-tag ${sold ? 'sold-tag--active' : ''}`}>
                  Sold
                </div>

              </div>
            </div>
          </div>
        </Fade>
        { !single && <Link className='property-hero-banner__link' to={pathName} /> }
      </div>
    )
  }
}

export default ProjectHeroBannerCard
